import React, { useState, useEffect, useMemo } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { getAttendeePhotoUrl, getEventImageUrl, getImageUrl } from "../../../utils/Helper";

const GalleryModal = (props) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const allImgData = Array.isArray(props.filesData?.[0])
    ? props.filesData[0]
    : props.filesData;

  const slides = useMemo(
    () =>
      (allImgData || [])
        .map((img) => {
          if (typeof img === "string") {
            return { src: getImageUrl(img) };
          }
          const src =
            getEventImageUrl(img, "") ||
            getAttendeePhotoUrl(img, "") ||
            getImageUrl(img?.path || img?.filename || "");
          return src ? { src } : null;
        })
        .filter(Boolean),
    [allImgData]
  );

  useEffect(() => {
    setIsOpen(props.Open);
    setPhotoIndex(props.Index);
  }, [props]);

  return (
    <Lightbox
      open={isOpen}
      close={() => {
        setIsOpen(false);
        props.onClose();
      }}
      index={photoIndex}
      slides={slides}
      on={{
        view: ({ index }) => setPhotoIndex(index),
      }}
    />
  );
};

export default GalleryModal;
